var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-wrapper"}},[(_vm.$route.name !== 'components-tests')?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('router-view')],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }